import { Form } from 'antd'
import { useCallback } from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import { appRoutes } from '../../../containers/Router/routes'
import { useCreateMutation } from '../../../query'

const useLocationCreate = () => {
  const [form] = Form.useForm()

  const history = useHistory()

  const [createLocation, { status: createStatus }] = useCreateMutation('locations')

  const onFinish = useCallback(async () => {
    try {
      const values = await form.validateFields()

      const location = await createLocation({
        ...values
      })

      history.replace(
        generatePath(appRoutes.locationShow.routes.details.path, {
          id: location._id
        })
      )
    } catch (e) {
      console.log(e)
    }
  }, [form])

  return {
    form,
    onFinish,
    createLoading: createStatus === 'loading'
  }
}
export default useLocationCreate
